import m from "./../../../dist/es2015/locales/pt_PT.js";
export const am5locales_pt_PT = m;